import { useQuery } from '@tanstack/react-query'
import type { ICurrency } from 'lib/helpers'
import api from 'lib/interceptor/axios.interceptor'

export const loadCurrencies = async () => {
	const response = await api.get(`/api/currencies`)
	return response.data as Record<string, ICurrency>
}

export const getExchangeRate = async (
	sourceCurrencyCode: string,
	targetCurrencyCode: string
) => {
	const response = await api.get(
		`/api/currencies/exchangeRate/${sourceCurrencyCode}/${targetCurrencyCode}`
	)

	return response.data as number
}

export const useLoadCurrency = () =>
	useQuery({
		queryKey: ['currency'],
		queryFn: async () => loadCurrencies()
	})
